import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LinksContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    height: fit-content;
`;

export const LinkContainer = styled.a`
    svg {
        fill: none;
        width: 35px;
        height: 34px;
    }

    circle,
    rect {
        stroke: ${({ theme }) => theme.Text.secondary};
    }

    path {
        fill: ${({ theme }) => theme.Text.secondary};
    }

    &:hover {
        circle {
            stroke: ${({ theme }) => theme.Text.primary};
        }

        path {
            fill: ${({ theme }) => theme.Text.primary};
        }
    }
`;
